import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http:HttpClient) { }

  getUsers(data:any){
    return this.http.post(environment.apiUrl + "userInformation/get/pagination" , data   );
  }
  
  updateUser(data:any){
    return this.http.post(environment.apiUrl + "userInformation/update" , data   );
  }
 

  searchUser(data:any){
    return this.http.post(environment.apiUrl + "userInformation/search" , data   );
  }

  sendOneTimePassword(data:any){
    return this.http.post(environment.apiUrl + "otp/generateResend" , data   );
  }

  verifyOneTimePassword(data:any){
    return this.http.post(environment.apiUrl + "otp/verify" , data   );
  }

}
